var relativeTime = { exports: {} };
export {
  relativeTime as __module
};
//# sourceMappingURL=relativeTime2.js.map
